import { useAuthState } from "@/contexts/auth/auth.provider";
import { useMutation } from "@apollo/client";
import { LOG_SPACE_ACTION } from "@/graphql/mutations/listing";
import { getPreviewToken } from "@/lib/paymentHelpers";
import Router, { useRouter } from "next/router";
import { Modal } from "@aqar-app/react-ui";
import logger from "@/console";
import React from "react";

import { ClassicModal } from "@/components/Listing/ListingScreen/classicModal";
import { ACTIONS_MAP } from "@/common/ACTIONS_MAP";
import { trackPopupInteraction } from "@/lib/tracking/trackMonthlyAd";
import { usePath } from "@/contexts/path/path";

const SPACE_TRANSACTION_TYPES = {
  60: "SELLING_LICENSING_FEES",
  61: "RENTING_LICENSING_FEES",
  83: "MONTHLY_LISTING_SPACE_FEES",
  default: "SUBSCRIBE",
};
export function SpacesModal({ space } = {}) {
  const { previousPath } = usePath();
  const { token } = useAuthState();

  const router = useRouter();
  const { accept_action, subscribe_action, close_action, title_ar, text_ar } =
    space?.popup || {};
  const [logSpaceAction] = useMutation(LOG_SPACE_ACTION, {
    context: { token },
  });

  const secondary_action = subscribe_action || close_action;
  return (
    <ClassicModal
      ok={{
        label: accept_action?.msg_ar,
        cb: (e) => {
          trackPopupInteraction({
            source: previousPath || decodeURI(document.referrer),
            target: "pay_ad_fee",
          });
          ClassicModal.loading("ok")(e);
          logSpaceAction({
            variables: {
              id: space.listing_id,
              text: space.popup.text_ar,
              action: space.popup.accept_action.action,
            },
          })
            .then(() =>
              getPreviewToken({
                value: space.transaction_type.value,
                type: space.transaction_type.description,
                pkgType: space.transaction_type.type_id,
                package_id: space.transaction_type.transaction_category,
                title: space.transaction_type.name,
                action:
                  SPACE_TRANSACTION_TYPES[space.transaction_type.type_id] ||
                  SPACE_TRANSACTION_TYPES.default,
                listing_id: space.listing_id,
                redirectTo: `/ad/${space.listing_id}?refetch=true`,
              }),
            )
            .then(({ token: preview }) => {
              router.push({
                pathname: "/payment-gateway/checkout",
                query: { preview },
              });
            })
            .then(() => Modal.close(e))
            .catch(logger.log);
        },
      }}
      cancel={{
        label: secondary_action?.msg_ar,
        cb: (e) => {
          trackPopupInteraction({
            source: previousPath || decodeURI(document.referrer),
            target: "subsribe_to_packges",
          });
          ClassicModal.loading("cancel")(e);

          logSpaceAction({
            variables: {
              id: space.listing_id,
              text: text_ar,
              action: secondary_action.action,
            },
          })
            .then(() => {
              const { route } = ACTIONS_MAP[secondary_action.action] || {};

              if (!route) return;
              return router.push(route);
            })
            .then(() => Modal.close(e))
            .catch(logger.log);
        },
      }}
      title={title_ar}
      body={text_ar}
      onClose={(e) => {
        trackPopupInteraction({
          source: previousPath || decodeURI(document.referrer),
          target: "cancel",
        });
        ClassicModal.loading("body")(e);
        logSpaceAction({
          variables: {
            id: space.listing_id,
            text: text_ar,
            action: close_action.action,
          },
        })
          .then(() => {
            const { route } = ACTIONS_MAP[close_action.action] || {};
            if (!route) return;
            return router.push(route);
          })
          .then(() => Modal.close(e));
      }}
    />
  );
}
